// Toast (Components, BL-189): what just happened, said once and gone ("Visit moved to 2 p.m.", "Sam is in
// Drains for today"), as a status a screen reader hears. At the foot of the screen it is ink with its words
// light, over what's under it; with nothing to press a tap passes through it, and with actions (Undo, Add
// why) it takes taps. In a panel (the board's open visit) it sits in the panel's flow as the ink mark down
// its start, so it never covers the panel's own buttons. The board's foot and panel toasts are its first
// uses; the app's other `.toast`s (HuddlePage's in DashboardPage's layers, Books, Settings…) move to it
// later. Reads only --toast-*.
import type { ReactNode } from 'react';
import './Toast.css';

export interface ToastProps {
  /** foot: over the screen, at its foot; panel: in a panel's flow, the ink mark down its start. */
  place?: 'foot' | 'panel';
  /** What just happened, in a sentence. */
  children: ReactNode;
  /** What can be done about it at once: Buttons, size sm (Undo, Add why). A foot toast with them takes taps. */
  actions?: ReactNode;
  id?: string;
}

export function Toast({ place = 'foot', children, actions, id }: ToastProps) {
  return (
    <div
      id={id}
      className="fl-toast"
      data-place={place}
      data-acts={actions != null ? '' : undefined}
      role="status"
    >
      {actions != null ? (
        <>
          <span className="fl-toast__words">{children}</span>
          {actions}
        </>
      ) : (
        children
      )}
    </div>
  );
}
